import React, { useState } from 'react';
import { toast } from 'sonner';
import { Trash2, Loader2 } from 'lucide-react';
import { notesApi } from '@/lib/notesApi';
import { extractError } from '@/lib/errors';

// Super admin: delete a wrongly recorded sale. groups = [{ sale, ids }] (empty ids = whole sold list).
export function DeleteSaleButton({ groups, label, text, onDone, testid }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      for (const g of groups) {
        // eslint-disable-next-line no-await-in-loop
        await notesApi.post(`/notes/tag-workspace/sales/${g.sale.id}/delete`, { item_ids: g.ids });
      }
      toast.success('Deleted. The pieces are back in stock.');
      setOpen(false);
      onDone();
    } catch (e) { toast.error(extractError(e, 'Could not delete the sale.')); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="inline-flex h-10 w-full items-center justify-center gap-1.5 rounded-xl border border-red-600/40 bg-red-600/5 text-sm font-semibold text-red-700 hover:bg-red-600/10 dark:text-red-400" data-testid={testid}><Trash2 size={14} /> {label}</button>
      {open ? (
        <div className="fixed inset-0 z-[300] flex items-center justify-center p-4" data-testid={`${testid}-dialog`}>
          <div className="absolute inset-0 bg-black/50" onClick={() => !busy && setOpen(false)} />
          <div className="relative w-full max-w-md rounded-2xl border border-border bg-card p-5 shadow-2xl animate-in fade-in zoom-in-95 duration-150">
            <div className="text-base font-semibold text-foreground">{label}?</div>
            <p className="mt-2 text-sm text-muted-foreground">{text} The pieces go back to stock as if they were never sold. This is not a sales return and cannot be undone.</p>
            <div className="mt-5 flex justify-end gap-2">
              <button type="button" disabled={busy} onClick={() => setOpen(false)} className="h-9 rounded-lg border border-border px-4 text-sm font-medium text-foreground hover:bg-secondary" data-testid={`${testid}-cancel`}>Cancel</button>
              <button type="button" disabled={busy} onClick={run} className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-red-600 px-4 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60" data-testid={`${testid}-confirm`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Trash2 size={14} />} Delete</button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
